import { render, staticRenderFns } from "./TableButtonsCopyObjectsDialog.vue?vue&type=template&id=09b7ad76&"
import script from "./TableButtonsCopyObjectsDialog.vue?vue&type=script&lang=js&"
export * from "./TableButtonsCopyObjectsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports